module.exports = __webpack_public_path__ + "static/media/whybtmside.493a6d63.webp";